"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingPage = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    loadingAreaContainer: _defineProperty({
      paddingBottom: "6rem",
      paddingTop: "12rem",
      paddingRight: "12rem",
      paddingLeft: "12rem"
    }, theme.breakpoints.down("sm"), {
      paddingLeft: 4,
      paddingRight: 4,
      paddingTop: "8rem"
    }),
    loadingTextContainer: {
      textAlign: "center"
    }
  };
});
var LoadingPage = function LoadingPage(props) {
  var classes = useStyles();
  var theme = (0, _core.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    className: classes.loadingAreaContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
    type: props.type || "bars",
    color: theme.palette.primary.main,
    height: 60,
    width: 60
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.loadingTextContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: props.loadingText || "veuillez patienter..."
  }))));
};
exports.LoadingPage = LoadingPage;